import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import { environment } from '../../../../environments/environment';
import { NewsListEntry } from '../../../model/v3/news';
import { Page, Pageable } from '../../../model/rest/base';
import { appendIfDefined, createPageableParams, serializeDateInput } from './rest-v3-utils';

@Injectable({
  providedIn: 'root',
})
export class NewsV3RestService {
  constructor(private http: HttpClient) {}

  private url(schoolId: number, managerId: number, path: string = ''): string {
    return `${environment.eventsApiBase}/v1/schools/${schoolId}/managers/${managerId}/news${path}`;
  }

  listNews(
    schoolId: number,
    managerId: number,
    unreadOnly?: boolean | null,
    pageable?: Pageable,
  ): Observable<Page<NewsListEntry>> {
      if(!schoolId || !managerId) return of(null)
    const params = appendIfDefined(createPageableParams(pageable), 'onlyUnread', unreadOnly);
    return this.http.get<Page<NewsListEntry>>(this.url(schoolId, managerId), { params });
  }

  getNewsById(
    schoolId: number,
    managerId: number,
    newsId: number,
  ): Observable<NewsListEntry | null> {
    return this.http.get<NewsListEntry | null>(this.url(schoolId, managerId, `/${newsId}`));
  }

  updateReadingDate(
    schoolId: number,
    managerId: number,
    newsId: number,
    date?: Date | string | null,
  ): Observable<void> {
    return this.http.patch<void>(
      this.url(schoolId, managerId, `/${newsId}/reading-date`),
      // a raw string body would be sent as text/plain, which the backend rejects
      JSON.stringify(serializeDateInput(date)),
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) },
    );
  }
}
